import {ReactElement} from "react";
import {useAppSelector} from "../../../lib/redux/hooks";
import {menuManagementSelectors} from "./menuManagementSlice";
import {ReactComponent as CheckedGreen} from "../../../components/Icons/checked-green.svg";
import {useIntl} from "react-intl";


export function CopyModalNotification(): ReactElement {
    const intl = useIntl();

    const copyNotification = useAppSelector(menuManagementSelectors.copyNotification);

    if (!copyNotification.open) {
        return <></>;
    }

    return <div className="relative">
        <div className="absolute w-full flex left-0 top-2.5 justify-center">
            <div className="border-[#27AE60] border-2 bg-white rounded-full
                flex justify-center items-center
                gap-5
                px-5 py-1
            ">
                <CheckedGreen className="h-8 w-8" />
                <div
                    dangerouslySetInnerHTML={{
                        __html: intl.formatMessage(
                            {id: "management.copy.notification"},
                            {
                                menuName: copyNotification.menuName,
                                userId: copyNotification.userId
                            }
                        )
                    }}
                />
            </div>
        </div>
    </div>;
}